module.exports = __webpack_public_path__ + "static/img/propaganda-1.5cdcbd13.jpeg";